(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rsa-hero"] && !Shopify.designMode) return;
  try {
    
/* Reveal no scroll — à prova de falha.
   O CSS só esconde sob `html.rsa-js`, então a classe abaixo é o que "liga" a
   animação. Se este script não rodar, nada some: o conteúdo fica visível.
   `rsaReveal()` é idempotente e roda de novo em shopify:section:load, porque
   o hot-reload e o editor de tema trocam o HTML da section depois que o
   observador já passou — e os elementos novos ficariam invisíveis para sempre. */
(function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var supported = 'IntersectionObserver' in window;

  if (reduceMotion || !supported) {
    document.querySelectorAll('.rsa-reveal').forEach(function (el) { el.classList.add('is-visible'); });
    return;
  }

  document.documentElement.classList.add('rsa-js');

  /* threshold 0: qualquer pixel visível já revela. Com threshold maior, um
     bloco alto podia atravessar a tela num scroll rápido sem nunca atingir a
     fração exigida — e ficava oculto para sempre. */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0, rootMargin: '0px 0px -40px 0px' });

  function mostrar(el) {
    el.classList.add('is-visible');
    io.unobserve(el);
  }

  function rsaReveal(root) {
    var vh = window.innerHeight || 0;
    (root || document).querySelectorAll('.rsa-reveal:not(.is-visible)').forEach(function (el) {
      var r = el.getBoundingClientRect();
      // já visível, ou já passou (scroll rápido / âncora / restauração de posição)
      if (r.top < vh && r.bottom > -1) mostrar(el);
      else if (r.bottom <= 0) mostrar(el);
      else io.observe(el);
    });
  }

  /* Rede de segurança: o observador sozinho já falhou na prática. Uma
     varredura barata no scroll (passiva, via rAF) garante que nada que já
     entrou ou passou pela tela continue invisível. */
  var agendado = false;
  function noScroll() {
    if (agendado) return;
    agendado = true;
    requestAnimationFrame(function () { agendado = false; rsaReveal(); });
  }

  rsaReveal();
  window.addEventListener('scroll', noScroll, { passive: true });
  window.addEventListener('resize', noScroll, { passive: true });
  document.addEventListener('shopify:section:load', function (e) { rsaReveal(e.target); });
  window.addEventListener('pageshow', function () { rsaReveal(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rsa-numbers"] && !Shopify.designMode) return;
  try {
    
var rsaCountReduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var rsaCounters = document.querySelectorAll('.rsa-cell__v [data-count]');
if (rsaCounters.length) {
  var rsaAnimateCount = function (el) {
    var target = parseInt(el.getAttribute('data-count'), 10) || 0;
    var duration = 1100;
    var start = null;
    var step = function (ts) {
      if (!start) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = Math.round(eased * target);
      if (progress < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };
  if (rsaCountReduceMotion || !('IntersectionObserver' in window)) {
    rsaCounters.forEach(function (el) { el.textContent = el.getAttribute('data-count'); });
  } else {
    var rsaCountIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          rsaAnimateCount(entry.target);
          rsaCountIO.unobserve(entry.target);
        }
      });
    }, { threshold: .4 });
    rsaCounters.forEach(function (el) { rsaCountIO.observe(el); });
  }
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rsa-product"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-rsa-qty]');
  if (!btn) return;
  var wrap = btn.closest('.rsa-qty');
  if (!wrap) return;
  var input = wrap.querySelector('.rsa-qty__input');
  if (!input) return;
  var step = parseInt(btn.getAttribute('data-rsa-qty'), 10) || 0;
  var next = (parseInt(input.value, 10) || 1) + step;
  input.value = next < 1 ? 1 : next;
  input.dispatchEvent(new Event('change', { bubbles: true }));
});

  } catch(e) { console.error(e); }
})();
})();
